import React from 'react';
import { Check } from 'lucide-react';
import { promises } from '../data/company';
export function PromiseBar() {
  return <div className="border-y border-gold-dark/40 bg-gold" data-id="element-97" data-mp="tqi4h7fskscw">
      <ul className="mx-auto flex max-w-6xl flex-wrap items-center gap-x-10 gap-y-2 px-6 py-3.5" data-id="element-98" data-mp="17qsw4coxeaz4">
        {promises.map(item => <li key={item} className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.16em] text-ink" data-id="element-99" data-mp="12t9klkjm4cav">
            <Check className="h-3.5 w-3.5" aria-hidden="true" data-id="element-100" data-mp="a3and1v9l8v4" />
            {item}
          </li>)}
      </ul>
    </div>;
}